module.exports = __webpack_public_path__ + "img/youshengjiang.745fcfdc.png";